import React, { useMemo, useState } from "react";

import {
  getChartOptions,
  getCenterLabelPlugin,
  mapChartData,
  getCustomLegendPlugin,
} from "@src/features/request_status_statistics_chart/utils/request_status_statistics_chart_utils";
import { RequestStatisticsSettings } from "@src/types/dashboard_types";
import { Card } from "antd";
import "./request_status_statistics_chart.less";
import {
  ArcElement,
  Chart,
  ChartData,
  ChartOptions,
  Legend,
  Tooltip,
  Plugin,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

import { DoughnutChartLegendItem } from "../doughnut_chart_legend_item";

Chart.register(ArcElement, Legend, Tooltip);

export interface RequestStatusStatisticsChartProps {
  chartSettings: RequestStatisticsSettings;
  isLoading?: boolean;
}

const RequestStatusStatisticsChart: React.FC<
  RequestStatusStatisticsChartProps
> = ({ isLoading, chartSettings }) => {
  const [legend, setLegend] = useState<React.ReactNode>();

  const chartData = useMemo<ChartData<"doughnut">>(() => {
    return mapChartData(chartSettings);
  }, [chartSettings]);

  const chartOptions = useMemo<ChartOptions<"doughnut">>(() => {
    return getChartOptions();
  }, []);

  const centerLabel: Plugin<"doughnut"> = getCenterLabelPlugin();
  const customLegend: Plugin<"doughnut"> = getCustomLegendPlugin(setLegend);

  return (
    <Card
      title="Requests & their states"
      className="request-status-statistics-chart"
      data-testid="request-status-statistics-chart"
      loading={isLoading}
    >
      <div className="request-status-statistics-chart__doughnut-chart">
        <Doughnut
          data={chartData}
          options={chartOptions}
          plugins={[customLegend, centerLabel]}
          data-testid="doughnut-chart"
        />
      </div>
      <div
        className="request-status-statistics-chart__legend legend"
        data-testid="legend"
      >
        {legend}
        <DoughnutChartLegendItem
          className="legend__item_total"
          text="Total Requests"
          count={chartSettings?.total}
        />
      </div>
    </Card>
  );
};

export default RequestStatusStatisticsChart;
